import * as types from './mutation-types'
import { getToken, getUserInfo } from '@/api/user.js'
import { getRobotList } from '@/api/robot.js'
// import { set } from '@/assets/js/common.js'
export default {
  state: {
    token: '',
    userinfo: {},
    robotlist: {},
    currentrobot: {},
    leftIndex: -1
  },
  mutations: {
    [types.SET_TOKEN] (state, token) {
      state.token = token
    },
    [types.SET_USERINFO] (state, info) {
      state.userinfo = info
    },
    [types.SET_ROBOTLIST] (state, list) {
      state.robotlist = list
    },
    [types.SET_CURRENT_ROBOT] (state, robot) {
      state.currentrobot = robot
    },
    [types.SET_LEFTINDEX] (state, index) {
      state.leftIndex = index
    }
  },
  actions: {
    setTooken ({commit}, {code}) {
      return getToken({code}).then(res => {
        if (res.data.code === 0) {
          let token = res.data.data.token_type + ' ' + res.data.data.token
          // set('turingToken', token)
          localStorage.setItem('turingToken', JSON.stringify({data: token}))
          commit(types.SET_TOKEN, token)
          return 0
        } else {
          return 1
        }
      }).catch(err => {
        console.error(err)
        return 1
      })
    },
    setUserinfo ({commit}) {
      return getUserInfo().then(res => {
        if (res.data.data) {
          commit(types.SET_USERINFO, res.data.data)
          return 0
        } else {
          return 1
        }
      })
    },
    setRobotlist ({commit}) {
      return getRobotList().then(res => {
        if (res.data.code === 0) {
          commit(types.SET_ROBOTLIST, res.data.data)
          return 0
        } else {
          return 1
        }
      })
    },
    setCurrentrobot ({commit}, robot) {
      commit(types.SET_CURRENT_ROBOT, robot)
    },
    setLeftindex ({commit}, index) {
      commit(types.SET_LEFTINDEX, index)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/publicinfo/index.js